<!--
  name : 김혜진
  desc : 비대면 관리자 사용자 로그 조회 화면
  * 기존 contractList 소스 가져다가 씀
  date : 
-->
<template>
  <v-container class="con_mpw">
    <v-card elevation="0" id="untactD">
      <div class="dot_tt row_mb-40">사용자 로그 조회</div>    
    <!-- [contractList] 검색 바 소스-->
      <v-row no-gutters class="search_bar_02 justify-start aling-center">
        <v-col cols="12" md="8">
          <v-row no-gutters>
            <v-col cols="auto">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on, attrs }">
                  <!--시작기간 고정 1달
                  최소: 1일/ 최대: 없음. -->
                  <v-text-field class="inputH48_02 calendar_at calendar_W_mg dpnone"
                    v-model="dateRangeText"
                    label="기간"
                    placeholder=" "
                    prepend-icon="mdi-calendar"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dates"
                  range
                  locale="ko-ko"
                >
                    <v-spacer></v-spacer>
                    <v-btn class="btn18_00"
                      outlined
                      @click="$refs.menu.save(dates)"
                    >
                      확인
                    </v-btn>
                    <v-btn class="btn18_00"
                      outlined
                      @click="menu = false"
                    >
                      취소
                    </v-btn>
                  </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="5" class="justify-center">
              <v-text-field class="inputH48_02 serch_W_mg dpnone"
                  v-model="searchCpnNum"
                  label="사업자 번호"
                  placeholder="사업자 번호 10자리"
                  maxlength="10"
                  clearable
                  outlined
                  dense
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" class="justify-start">
              <v-btn class="btn17_C01" @click="search()"><span class="icon search"></span></v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="3" class="untactD_btnCon">
          <v-btn outlined class="btn17_00"  @click="excelDown()"><span class="icon save"></span>엑셀 다운로드</v-btn>
        </v-col>
      </v-row>
    <!--/검색 바-->
      <v-row no-gutters>
        <v-col cols="12">
          <v-data-table class="unC-tbst"
            :search="searchCpnNum"
            :headers="headers"
            :items="dataList"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
          ></v-data-table>
          <v-pagination
            v-model="page"
            :length="total"
            @input="handlePageChange"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-card>
    <s-confirm ref="confirm"></s-confirm>
    <s-loading ref="loading"></s-loading>
  </v-container>
</template>
<script>

import { getVoucherLog, getVoucherLogExcelDown } from '@/api/voucher'
import XLSX from "xlsx"

export default {
  number: 'untact-document',
  components: {
  },
  filters: {
  },
  data () {
    return {
      // date picker
      dates: [],
      // data-table test
      menu: false,
      searchCpnNum:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      pageParam: {
        page: 0,
        size: 10
      },
      headers: [
        {
          text: '번호',
          align: 'start',
          value: 'no',
        },
        { text: '사업자번호', value: 'orgRegNo' },
        { text: '업체명', value: 'orgNm' },
        { text: '사용자 아이디', value: 'userId' },
        { text: '최종 로그인', value: 'loginDate' },
      ],
      voucherList: [],
      voucherExcelList: [],
      dataList: [],
      excelList: [],
      searchParams: {
        searchCpnNum: '',
        selectDateRange: [],
        pageParam: {
          page: 0,
          size: 10
        }
			},
    }
  },
  computed: {
    /*[contractList]dateRangeText*/
    dateRangeText () {
      if(this.dates.length === 2) {
        var start = this.dates[0]
        var end = this.dates[1]
        if(start > end) {
          this.dayChange(start, end)
          return this.dates.join(' ~ ')
        }else{
          return this.dates.join(' ~ ')
        }
      }else {
        return this.dates.join(' ~ ')
      }
    },
  },
  mounted () {
    if(this.$store.state.user.adminLogin !== 'success' ) {
      this.$router.push('voucher')
    }
    this.$nextTick(() => {
      this.defaultSetting()
      //this.search()
    })
  },
  methods: {
    dayChange(start, end) {
      this.dates = [end, start]
    },
    defaultSetting () {
      
      var date = new Date();
      var year = date.getFullYear();
      var lastyear = date.getFullYear();
      var month = date.getMonth() +1;
      month = month >= 10 ? month : '0' + month;
      var day = date.getDate();
      day = day >= 10 ? day : '0' + day;
      var lastMonth = month -1
      lastMonth = lastMonth >= 10 ? lastMonth : '0' + lastMonth;
      if(month === '01') {
        lastMonth = '12'
        lastyear = year -1
      }
      
      var start = lastyear + '-' + lastMonth + '-' + day;
      var end =  year + '-' + month + '-' + day;
      this.dates = [start, end]
      return this.dates.join(' ~ ')

    },
    search() {
      if (this.dateRangeText === null || this.dateRangeText.length === 0 || !this.dateRangeText) {
        this.searchParams.selectDateRange = '1900-01-01 ~ ' + this.getStartNEndDate('end')
      } else {
        this.searchParams.selectDateRange = this.dateRangeText
      }
      if(this.dates.length === 1) {
        this.$refs.confirm.open('alert', '리스트조회', '검색일자를 확인해주세요')
        return
      }
      if(this.searchCpnNum.length !== 10) {
        this.$refs.confirm.open('alert', '리스트조회', '사업자등록번호를 확인해주세요')
        return
      }
      this.searchParams.searchCpnNum = this.searchCpnNum
      if (this.searchParams !== null) {
        var searchParams = this.searchParams
        searchParams.pageParam = this.pageParam
        this.$refs.loading.start('리스트 조회 중입니다.')
        getVoucherLog(searchParams).then(response => {
          this.$refs.loading.end()
          this.voucherList = response.rdata.voucherList
          if(this.voucherList !== null && this.voucherList.length > 0) {
            this.dataList = []
            this.voucherList.forEach((item, index) => {
              let dataBase = {}
              dataBase = {
                no: item.no,
                orgRegNo: item.orgRegNo,
                orgNm: item.orgNm,
                userId: this.convertId(item.userId),
                loginDate: this.convertDate(item.loginDate)
              }
              this.dataList.push(dataBase)
            })
          }
          var a = 0
          if(parseInt(response.rdata.totalCnt % 10) > 0) {
            a = 1
          }
          this.total = parseInt(response.rdata.totalCnt / 10) + a
        }).catch(e => {
          console.error(e)
        })
      }
    },
    excelDown() {
      getVoucherLogExcelDown(this.searchParams).then(response => {
          this.$refs.loading.end()
          this.voucherExcelList = response.rdata.voucherExcelList
          if(this.voucherExcelList !== null && this.voucherExcelList.length > 0) {
            this.excelList = []
            this.voucherExcelList.forEach((item, index) => {
              let excelBase = {}
              excelBase = {
                번호: item.no,
                사업자번호: item.orgRegNo,
                업체명: item.orgNm,
                아이디: this.convertId(item.userId),
                로그인일시: this.convertDate(item.loginDate)
              }
              this.excelList.push(excelBase)
            })
          }
          const dataWS = XLSX.utils.json_to_sheet(this.excelList);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, dataWS, "로그인이력");
          XLSX.writeFile(wb, "login_history.xlsx")
        }).catch(e => {
          console.error(e)
        })
    },
    handlePageChange(value) {
      this.pageParam.page = (value - 1)
      this.search()
    },
    getStartNEndDate (signal) {
      // 현재일자로부터 1년전 날짜
      const start = moment(new Date()).add(-1,'year').format('YYYY-MM-DD')
      const end = moment(new Date()).add(0,'hour').format('YYYY-MM-DD')
      return signal === 'start'?start:end
    },
    convertDate(date) {
      if(date === '') {
        return ''
      }
      const js_date = new Date(date)

      let year = js_date.getFullYear()
      let month = js_date.getMonth() + 1
      let day = js_date.getDate()

      if(month < 10) {
        month = '0' + month
      }
      if(day < 10) {
        day = '0' + day
      }
      const hour = ('0' + js_date.getHours()).slice(-2)
      const minute = ('0' + js_date.getMinutes()).slice(-2)
      const second = ('0' + js_date.getSeconds()).slice(-2)

      return year+'-'+month+'-'+day+' '+hour+':'+minute+':'+second
    },
    convertId(id) {
      let uid = id
      if(id.length > 20) {
        uid = uid.substr(0,20) + '...'
      }
      return uid
    }
  }
}
</script>
<style>
#untactD {
    margin: 0px auto;
    margin-bottom: 40px;
    padding: 40px 30px;
    overflow: hidden;
    width: 100%;
    max-width: 1480px;
    height: calc(100vh - 100px);
    min-height: 640px;
}
.untactD_btnCon{text-align: right;}
.untactD_btnCon .btn17_00:first-child{margin-left: 0 !important;}
.untactD_btnCon .btn17_00:last-child{margin-right: 0 !important;}
.unC-tbst{margin-bottom: 20px; border-top: 2px solid #413f3e; border-bottom: 1px solid #cccccc; border-radius: 0;}
.unC-tbst td{color: #949494;}
@media (max-width:1520px) {
    #untactD {
        width: 100%;
        height: auto;
        min-height: calc(100vh - 100px);
    }
}

@media (max-width:960px) {
    .untactD_btnCon{margin-top: 10px;}
}
</style>